export default function (existingEmail = '') {
  return {
    member: 1,
    emailAddress: existingEmail,
    password: '',
    remember: 1
  }
}
